// Shared helpers for rendering and sharing a single payment transaction.
// Extracted from TxnHistory.js so TxnTable cards (landlord side) can
// match the rich txn card visual + share-receipt UX without
// duplicating the method-label map or the share-fallback logic.

const _METHOD_LABELS = {
  cash: "Cash",
  upi: "UPI",
  bank: "Bank Transfer",
  cheque: "Cheque",
  razorpay: "Online (Razorpay)",
};
export function methodLabel(m) {
  if (!m) return "—";
  return _METHOD_LABELS[m] || String(m).toUpperCase();
}

// Build a plain-text receipt for one transaction. Small enough to fit
// a WhatsApp message, readable as-is in a chat.
export function buildReceiptText(tx, payment, tenant, propertyAddr, t, stLabel) {
  const lines = [
    "🧾 Payment Receipt",
    "──────────────",
  ];
  if (tenant?.name) lines.push(`Tenant : ${tenant.name}`);
  if (propertyAddr) lines.push(`Property: ${propertyAddr}`);
  if (payment?.mo) lines.push(`Month  : ${payment.mo}`);
  lines.push(`Amount : ₹${Number(tx.amt || 0).toLocaleString('en-IN')}`);
  lines.push(`Method : ${methodLabel(tx.mth)}`);
  lines.push(`Date   : ${tx.dt || "—"}`);
  lines.push(`Status : ${(stLabel[tx.status] || tx.status || "").replace(/[✓✕⏳]\s?/g, '')}`);
  const typeLabel = tx.type === "full" ? (t.fullPay || "Full Payment")
    : (tx.type || "").startsWith("advance") ? (t.advancePay || "Advance Payment")
    : (t.partialPay || "Partial Payment");
  lines.push(`Type   : ${typeLabel}`);
  if (tx.totalWas > 0 && tx.totalWas !== tx.amt) {
    lines.push(`(Total bill: ₹${Number(tx.totalWas).toLocaleString('en-IN')})`);
  }
  lines.push("──────────────");
  lines.push("via ProRentz");
  return lines.join("\n");
}

// Try the native share sheet first (mobile / Edge). If unavailable or
// the user cancels, fall back to WhatsApp Web, then to clipboard.
export async function shareReceipt(text, flash, t) {
  if (navigator.share) {
    try {
      await navigator.share({ title: "Payment Receipt", text });
      return;
    } catch (e) {
      if (e?.name === "AbortError") return;
    }
  }
  try {
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  } catch (e) { /* fall through */ }
  try {
    await navigator.clipboard.writeText(text);
    flash?.(t?.receiptCopied || "Receipt copied to clipboard");
  } catch (e) {
    flash?.(t?.shareFailed || "Could not share receipt", "error");
  }
}
